import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { CoreModule } from './core/core.module';
import { AuthModule } from './modules/auth/auth.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxsModule } from '@ngxs/store';
import { environment } from 'src/environments/environment';
import { AuthState } from './store/auth/auth.state';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxsActionsExecutingModule } from '@ngxs-labs/actions-executing';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { MyAccountModule } from './modules/my-account/my-account.module';
import { MyAccountState } from './store/my-account/my-account.state';
import { RequestsModule } from './modules/requests/requests.module';
import { RequestsState } from './store/requests/requests.state';
import { RegistrationState } from './store/registration/registration.state';
import { SettingsState } from './store/settings/settings.state';
import { ApiInstructionModule } from './modules/api-instruction/api-instruction.module';
import { ApiInstructionState } from './store/api-instruction/api-instruction.state';
import { RecaptchaInterceptor } from './core/interceptors/recaptcha/recaptcha.interceptor';
import { ApiConfigService } from './core/services/api-config/api-config.service';

export function initConfig(configService: ApiConfigService) {
  return () => configService.loadConfig();
}

export function loadRecaptchaScript(configService: ApiConfigService) {
  return () => {
    return new Promise<void>((resolve) => {
      const siteKey = configService.recaptchaSiteKey;

      if (!siteKey || !configService.recaptchaEnabled) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve();
      };
      script.onerror = () => {
        resolve();
      };
      document.head.appendChild(script);
    });
  };
}
@NgModule({
  declarations: [AppComponent, AuthLayoutComponent, ContentLayoutComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    AuthModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    FlexLayoutModule,
    MyAccountModule,
    RequestsModule,
    ApiInstructionModule,
    NgxsModule.forRoot(
      [
        RegistrationState,
        AuthState,
        MyAccountState,
        RequestsState,
        SettingsState,
        ApiInstructionState,
      ],
      {
        developmentMode: !environment.production,
      }
    ),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    NgxsActionsExecutingModule.forRoot(),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ApiConfigService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadRecaptchaScript,
      deps: [ApiConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RecaptchaInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
